import * as React from "react";
import { authSocialButtonClass } from "@/components/auth/auth-ui";
import { libraryGlowButtonClass } from "@/features/library/lib/library-ui";
import { cn } from "@/lib/utils";

export interface SocialButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  icon: React.ReactNode;
  label: string;
  /** Applies disabled visual styles via CSS only — does NOT set the native disabled attribute, so click events (e.g. analytics) still fire. */
  visuallyDisabled?: boolean;
}

export const SocialButton = React.forwardRef<
  HTMLButtonElement,
  SocialButtonProps
>(
  ({ icon, label, className, visuallyDisabled, disabled, ...props }, ref) => {
  return (
    <button
      ref={ref}
      disabled={visuallyDisabled ? false : disabled}
      aria-disabled={visuallyDisabled || disabled}
      className={cn(
        libraryGlowButtonClass,
        authSocialButtonClass,
        "disabled:pointer-events-none disabled:opacity-60",
        visuallyDisabled && "cursor-not-allowed opacity-60",
        className
      )}
      {...props}
      {...(visuallyDisabled && { onClick: (e: React.MouseEvent<HTMLButtonElement>) => e.preventDefault() })}
    >
      <span aria-hidden className="mr-1">
        {icon}
      </span>
      <span>{label}</span>
    </button>
  );
});

SocialButton.displayName = "SocialButton";

export default SocialButton;
